import { atom, useRecoilState } from 'recoil';

/**
 * This file contains UI state related to breakouts.
 */

export type BreakoutView = 'start' | 'configure' | 'ongoing' | 'end';
const breakoutViewState = atom<BreakoutView | null>({
  key: 'breakout-view',
  default: 'start',
});
/**
 * Used to control visibility and tabs for breakout views in the sidebar.
 */
export const useBreakoutView = () => useRecoilState(breakoutViewState);

const joinBreakoutModalState = atom<boolean>({
  key: 'join-breakout-modal-state',
  default: false,
});
/**
 * Used to control visibility of JoinBreakoutModal.
 */
export const useJoinBreakoutModal = () =>
  useRecoilState(joinBreakoutModalState);
